module.exports = __webpack_public_path__ + "02fa0f896af721aab671e9deaa34a84f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-harry-s.png
// module id = 2333
// module chunks = 0